/// <amd-module name="Core/Medius.Core.Web/Scripts/shared/store/hooks"/>

import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from 'Core/Medius.Core.Web/Scripts/shared/store/reduxStore';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;